import React, { useContext } from "react";
import styles from "./StoryDate.module.scss";
import PathContext from "../../context/path";
import clsx from 'clsx';

const StoryDate = (props) => {
  const {date, title, color, className} = props;
  const path = useContext(PathContext);
  
  let wrapClass = `${styles.wrap}`;
  let dateElement = null;
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${color}`]}`;
  }
  if (date !== undefined ) {
    dateElement = <div className={styles.date}>{date}</div>
  }
  return (
    <>
      <div className={clsx(wrapClass, className)}>
        <div className={styles.inner}>
        {dateElement}
        <h2 className={styles.title} data-animate={'fade-in-up'}>{title}</h2>
      </div>
      </div>
    </>
  );

}

export default StoryDate;
